<template>
  <v-btn
    :class="typeof widget.data.link==='undefined' ? 'mt-3 cursorNoneT' : 'mt-3'"
    @click="() => typeof widget.data.link!=='undefined' ? move(widget.data.link) : null"
    v-if="widget.type==='tile' && widget.data.template==='btnDesign'"
    :style="widget.data.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79)' : widget.data.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335)' : widget.data.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443)' : widget.data.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000)' : 'background:' + widget.data.color "
    dark
    block
  >
    {{ widget.data.title }} <template v-if="widget.data.model!=='no'">{{ widget.data.model }} {{ widget.data.prefix }}</template>
  </v-btn>
</template>

<script>
import router from "@/router";

export default {
  name: "tile-btn-design",
  props: {
    widget: Object
  },
  methods: {
    move(link) {
      let result = link.includes("http");
      if (result) {
        window.location.href = link
      } else {
        router.push(link)
      }
    }
  }
}
</script>

<style>
.cursorNoneT{
  cursor: default !important;
}
</style>
